import { AdContainer } from "./ad-container";

interface InContentAdProps {
  slot?: string;
  className?: string;
}

export function InContentAd({ slot, className }: InContentAdProps) {
  return <AdContainer format="rectangle" slot={slot} className={className} />;
}
